<!--ReclamationInvoice-->
<template>
  <div class="">

    <div>
      <the-navbar-horizontal
          class="no-print"
          :navbarType="navbarType"
          :class="'text-base'"/>
    </div>

    <div class="float-right inline-flex mt-6 no-print">
      <vs-button @click="printInvoice">Print</vs-button>
    </div>

    <div class="print-invoice">


      <div class="page-content" v-if="invoice">



        <table class="top-table">

          <thead>
          <tr>
            <td>
              <!--place holder for the fixed-position header-->
              <div class="page-header-space"></div>
            </td>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td>
              <div class="block mb-6 w-full">
                <div class="page-header" style="text-align: center; color: #e36c0a !important;">
                  <div class="header-invoice w-full">
                    <div class="header-title">
                      <div class="header-title-bg flex flex-col text-left">
                        <p>
                          {{ invoice.invoice_data.parent_organisation.organisation_name }}
                        </p>
                        <p>
                          {{ invoice.invoice_data.parent_organisation.address }}
                        </p>
                        {{ invoice.invoice_data.parent_organisation.house_no }},
                        {{ invoice.invoice_data.parent_organisation.postal_code }},
                        {{ invoice.invoice_data.parent_organisation.city }}
                        <p>
                          Tel: {{ invoice.invoice_data.parent_organisation.mobile }}
                        </p>
                        <p>
                          Email: {{ invoice.invoice_data.parent_organisation.email }}
                        </p>
                        <p>
                          TVA: {{ invoice.invoice_data.parent_organisation.ustldnr }}
                        </p>
                        <!--                <p class="header-title-text">-->
                        <!--                  {{ invoice.invoice_data.parent_organisation.organisation_name }}-->
                        <!--                </p>-->
                      </div>
                    </div>
                    <vs-spacer></vs-spacer>
                    <div class="header-invoice-details flex justify-end items-center">
                      <img class=""
                           :src="getlogo()"/>
                      <!--                                    <img class=""-->
                      <!--                                         src="https://rt-services.be/media/rts_0G37Ft8_50_e5YqFQc.png"/>-->
                      <span class="header-invoice-tittle">
<!--              GUTSCHRIFT-->

            </span>
                    </div>
                  </div>
                  <div style="border: 1px solid;">
                  </div>
                </div>
                <div class="flex justify-end" style="margin-right: 120px;">
                  <div class="width-400 text-bold text-end">
                    <p>{{ invoice.invoice_data.child_organisation.organisation_name }}</p>
                    <p>
                  <span v-if="invoice.invoice_data.child_organisation.address">
                    {{ invoice.invoice_data.child_organisation.address }}
                  </span>
                      <span v-if="invoice.invoice_data.child_organisation.house_no">
                    {{ invoice.invoice_data.child_organisation.house_no }}
                  </span>
                    </p>
                    <p>
                   <span v-if="invoice.invoice_data.child_organisation.postal_code">
                    {{ invoice.invoice_data.child_organisation.postal_code }}
                  </span>
                      <span v-if="invoice.invoice_data.child_organisation.city">
                    {{ invoice.invoice_data.child_organisation.city }}
                  </span>
                    </p>
                    <p v-if="invoice.invoice_data.child_organisation.ustldnr">
                      TVA: {{ invoice.invoice_data.child_organisation.ustldnr }}
                    </p>
                  </div>
                </div>

                <!--                <div class="width-400 align-start top-side-bar">-->
                <!--                  <p class="text-bold">{{ invoice.invoice_data.child_organisation.organisation_name }}</p>-->
                <!--                  <p>{{ invoice.organisation_first_name }} {{ invoice.organisation_last_name }}</p>-->
                <!--                  <p>{{ invoice.invoice_data.child_organisation.address }}-->
                <!--                    {{ invoice.invoice_data.child_organisation.house_no }}</p>-->
                <!--                  <p>{{ invoice.invoice_data.child_organisation.postal_code }}-->
                <!--                    {{ invoice.invoice_data.child_organisation.city }}</p>-->
                <!--                  <p>St.Nr: {{ invoice.invoice_data.child_organisation.stnr }}</p>-->
                <!--                  <p>Ustldnr: {{ invoice.invoice_data.child_organisation.ustldnr }}</p>-->
                <!--                </div>-->
                <!--                <div class="flex justify-end top-side-bar">-->
                <!--                  <div class="width-400 pt-2">-->
                <!--                    <table class="custom-customer-table w-full text-end">-->
                <!--                      <tr>-->
                <!--                        <td>-->
                <!--                          Kunden Nr-->
                <!--                        </td>-->
                <!--                        <td>:</td>-->
                <!--                        <td>{{ invoice.customer_id }}</td>-->
                <!--                      </tr>-->
                <!--                      <tr>-->
                <!--                        <td>-->
                <!--                          Beleg Nr-->
                <!--                        </td>-->
                <!--                        <td>:</td>-->
                <!--                        <td>{{ invoice.invoice_no }}</td>-->
                <!--                      </tr>-->
                <!--                      <tr>-->
                <!--                        <td>-->
                <!--                          Lief.Datum von-->
                <!--                        </td>-->
                <!--                        <td>:</td>-->
                <!--                        <td>{{ invoice.invoice_data.from_date | onlyDateFormat }}</td>-->
                <!--                      </tr>-->
                <!--                      <tr>-->
                <!--                        <td>-->
                <!--                          Lief.Datum bis-->
                <!--                        </td>-->
                <!--                        <td>:</td>-->
                <!--                        <td class="header-invoice-table-date">{{ invoice.invoice_data.to_date | onlyDateFormat }}</td>-->
                <!--                      </tr>-->
                <!--                      <tr>-->
                <!--                        <td>-->
                <!--                          Beleg.Datum-->
                <!--                        </td>-->
                <!--                        <td>:</td>-->
                <!--                        <td class="header-invoice-table-date">{{-->
                <!--                            invoice.invoice_data.invoice_date | onlyDateFormat-->
                <!--                          }}-->
                <!--                        </td>-->
                <!--                      </tr>-->
                <!--                    </table>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>

              <div class="text-bold text-center py-2 my-2">
                <span class="invoice-text-title underline">CREDIT NOTE</span>
              </div>
              <div class="text-bold header-title pb-2 underline">
                <span class="">Reklamation from {{
                    invoice.invoice_data.from_date | onlyDateFormat
                  }} to {{ invoice.invoice_data.to_date | onlyDateFormat }}</span>
              </div>

              <div class="text-bold header-title font-bold flex flex-row justify-between">
                <p>Facture No: {{ invoice.reclamation_invoice_no }}</p>
                <p>Facture Date: {{ invoice.invoice_data.invoice_date | onlyDateFormat }}</p>
                <p>Client Nr: {{ invoice.customer_id }}</p>
                <p>TVA:{{ invoice.ustldnr }}</p>
              </div>


              <div>
                <table class="custom-table-data" style="">
                  <thead>
                  <tr class="table-header">
                    <th class="width-40">Sl No</th>
                    <th class="thead-item-product">Description</th>
                    <th class="width-80">Item Rate</th>
                    <th class="width-40">Quantite</th>
                    <th class="width-80">Prix Unitaire</th>
                    <th class="width-80">Total</th>
                    <th class="width-80">Remise</th>
                    <th class="width-80">Payer</th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      :class="[
                      {'table-data-border': true }
                    ]"
                      class="table-data table-bg-color" v-for="(d, dindex) in chunkedInvoice">
                    <td class="text-center data-border-left-white">{{ dindex + 1 }}</td>
                    <td>{{ getTitle(d.product_name) }} - {{ d.product_type }}</td>
                    <td class="text-center no-word-break">{{ d.denomination | germanNumberFormat }}</td>
                    <td class="text-center">-{{ d.quantity }}</td>
                    <td class="text-center">-{{ d.prix_unitare | germanNumberFormat }}</td>
                    <td class="text-center no-word-break">-{{
                        d.denomination * d.quantity | germanNumberFormat
                      }}
                    </td>
                    <td class="text-center no-word-break">-{{
                        d.remise | germanNumberFormat
                      }}
                    </td>
                    <td class="text-center no-word-break">-{{
                        d.payer | germanNumberFormat
                      }}
                    </td>
                  </tr>
                  <tr class="table-data">
                    <th></th>
                    <th colspan="4" class="pr-2" style="text-align: end !important;">Total</th>
                    <th colspan="1">-{{ invoice.invoice_data.total_amount | germanNumberFormat }}</th>
                    <th colspan="1">-{{ invoice.daily_report_data.total_remise | germanNumberFormat }}</th>
                    <th colspan="1">-{{ invoice.daily_report_data.total_payer | germanNumberFormat }}</th>
                  </tr>
                  </tbody>

                </table>
                <div class="flex flex-row px-4 font-bold">
                  <p>TVA 0%</p>
                </div>
                <div class="flex flex-row items-start justify-end w-full">
                  <table>
                    <tr class="table-data">
                      <th style="border: none" colspan="5"></th>
                      <th style="border: none" colspan="1">
                        Total Remise:
                      </th>
                      <th colspan="3" style="text-align: end; font-size: 20px;">
                        - {{ invoice.daily_report_data.total_remise | germanNumberFormat }}
                      </th>
                    </tr>

                    <tr class="table-data">
                      <th style="border: none" colspan="5"></th>
                      <th style="border: none" colspan="1">
                        Total Payer:
                      </th>
                      <th colspan="1" style="text-align: end; font-size: 20px;">
                        -{{ invoice.daily_report_data.total_payer | germanNumberFormat }}
                      </th>
                    </tr>
                  </table>
                </div>
              </div>
            </td>
          </tr>

          </tbody>

          <tfoot>
          <tr>
            <td>
              <!--place holder for the fixed-position footer-->
              <div class="page-footer-space"></div>

            </td>
          </tr>
          </tfoot>

        </table>
        <div id="page-footer" class="page-footer text-xl" style="margin-top: 8px;">
          <div class="flex flex-col text-center">
            <p class="underline flex flex-row space-x-4 w-full justify-center">
              <strong>BNP FORTIS: BE12 0016 2684 4792 </strong><strong>Belfius: BE91 0682 5102 1576</strong><strong>ING: BE98 3631 4589 3393</strong>
            </p>
            <p style="font-size: 10px;line-height: 10px;text-align: start; padding: 2px 4px">
              Commission sur cartes telephoniques non taxees par decision adminstratives N°E.T 107.384 du 10november 2004
            </p>
            <p style="font-size: 10px;line-height: 10px;text-align: start;background: #9d9d9d; padding: 2px 4px">
              CONDITIONS GENREALES DE VENTE : Tout retard de paiement entraînera une majoration, de plein droit et sans mise en demeure préalable de 12 % l'an, augmentée d'une indemnité forfaitaire et irréductible de 18%, avec un minimum de 75€. Outre cet intérêt, le montant de nos factures pourra également être majoré de 12,50€ pour un courrier envoyé et de 25€ pour le déplacement d'une personne. Les dépens de justice et les éventuels frais de défense seront en outre à charge du débiteur. Conformément à l'article 32.15 de la Loi du 14/7/1991 modifiée par la Loi du 6/04/2010 à l'article 74.17 sur les pratiques du commerce, il est précisé que les présentes conditions générales contractuelles sont d'application réciproque entre les parties. Toute contestation, pour être recevable, doit être notifiée, sous huitaine, par recommandé, dès réception de la facture. Un changement d'adresse ne peut valoir excuse de n'avoir pas eu connaissance de la facture ou de ne pas l'avoir protestée dans les délais.
            </p>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
import navMenuItems from '@/layouts/components/vertical-nav-menu/navMenuItems'
import resellerNavMenuItems from '@/layouts/components/vertical-nav-menu/resellerNavMenuItems'
import sellerNavMenuItems from '@/layouts/components/vertical-nav-menu/sellerNavMenuItems'

import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal'
import * as adminNav from '@/layouts/components/vertical-nav-menu/navMenuItems'
import * as resellerNav from '@/layouts/components/vertical-nav-menu/resellerNavMenuItems'
import * as sellerNav from '@/layouts/components/vertical-nav-menu/sellerNavMenuItems'
import themeConfig from '../../../../../themeConfig'

export default {
  name: 'ViewInvoice',
  data() {
    return {
      navbarType: themeConfig.navbarType || 'floating',
    }
  },
  props: {
    invoiceId: {
      type: String,
    },
  },
  components: {
    TheNavbarHorizontal,
  },
  computed: {

    chunkedInvoice() {
      return this.invoice.invoice_data.table_data
      const result = []
      const arr = this.invoice.invoice_data.table_data
      for (let i = 0; i < arr.length; i += 2) result.push(arr.slice(i, i + 2))
      return result
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    getNavMenuItems() {
      const role = this.activeUserInfo.account_role
      switch (role) {
        case 0:
          adminNav.reload()
          return adminNav.navMenuItems
        case 1:
          resellerNav.reload()
          return resellerNav.navMenuItems
        case 2:
          sellerNav.reload()
          return sellerNav.navMenuItems
        case 3:
          adminNav.reload()
          return adminNav.navMenuItems
        default:
          return []
      }
    },
    invoice() {
      return this.$store.state.invoice.invoice
    },
  },
  mounted() {
    document.getElementsByTagName('title')[0].innerText = ''
    setTimeout(() => {
      try {
        document.getElementsByClassName('theme-dark')[0].classList = 'no-theme-dark'
      } catch (e) {
      }
    }, 3000)
    this.fetchInvoice()
  },
  beforeDestroy() {
    setTimeout(() => {
      try {
        document.getElementsByClassName('no-theme-dark')[0].classList = 'theme-dark'
      } catch (e) {
      }
    }, 3000)
  },
  created() {
    setTimeout(() => {
      try {
        document.getElementsByTagName('footer')[0].remove()
      } catch (e) {
      }
    }, 3000)
  },
  methods: {
    getlogo() {
      if (this.invoice.invoice_data.parent_organisation.logo) {
        return this.invoice.invoice_data.parent_organisation.logo
      }

      return this.invoice.parent_organisation_logo
    },
    getTitle(d) {
      if (typeof (d) === 'string') {
        return d
      }
      try {
        const keys = Object.keys(d)
        if (keys.indexOf('provider_name_with_country') !== -1) {
          return d.provider_name_with_country
        } if (keys.indexOf('provider') !== -1) {
          return d.provider
        }
        return '-'
      } catch (e) {
        return '-'
      }
    },
    printInvoice() {
      document.title = `${this.invoice.invoice_credit_id}`
      window.print()
    },
    fetchInvoice() {
      const payload = { invoice_id: this.invoiceId }
      this.$vs.loading()
      return this.$store.dispatch('invoice/fetchReclamationInvoice', { payload })
          .then((data) => {
            this.$vs.loading.close()
            this.errorFetching = false
          })
          .catch((error) => {
            this.$vs.loading.close()
            this.errorFetching = true
            this.$vs.notify({
              position: 'top-center',
              title: 'Error',
              text: error.response.data.message || error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            })
          })
    },
  },
}
</script>


<style lang="scss">

.layout--full-page {
  background: white !important;
}

.print-invoice {
  font-size: 20px !important;
  color: black !important;
  font-family: serif !important;
  padding: 10px 16px;


  .text-end {
    text-align: end;
  }

  .header-title {
    font-weight: bold;
    font-size: 1.1rem;
  }

  th, td {
    font-size: 14px !important;
  }

  .text-bold {
    font-weight: bold;
  }

  .top-table {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 12px;
  }

  .page-footer {
    //position: fixed;
    //bottom: 0;
    width: 100%;
    border-top: 1px solid #0000003D;
    color: black;
    background-color: white;
  }

  .page-header {
    //position: fixed;
    top: 0mm;
    width: 100%;
  }

  .page {
    page-break-after: always;
  }

  .page-head-image {
    height: 140px;
  }

  .align-end {
    text-align: start;
    display: flex;
    justify-content: flex-end;
  }

  .width-400 {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
  }

  .align-start {
    text-align: start;
  }

  .custom-customer-table {
    tr {
      td {
        padding-right: 10px;
      }
    }
  }

  .table-oneline {
    border: 1px solid #000000;

    tr {
      td, th {
        border: 1px solid #000000;
        padding: 0px 10px;
      }
    }
  }

  .header-invoice {
    display: flex;
    height: 140px;
    background: white;

    .header-title {
      display: inline-flex;
      flex: 1 1 100%;
      margin-right: 48px;
    }

    .header-title-text {
      color: black;
      font-size: 52px;
      text-align: start;
      padding: 0 16px;
      align-content: center;
      height: 140px;
      display: grid;

    }

    .header-invoice-details {
      //width: 273px;
      height: 140px;
      text-align: start;
      display: flex;
      justify-content: flex-end;

      img {
        height: 130px;
        object-fit: contain;
      }

      .header-invoice-tittle {
        font-size: 44px;
        color: #1e90ff;
        font-weight: bolder;
        align-content: center;
        height: 113px;
        display: grid;
      }

      .header-invoice-table {
        border: none;
        width: 100%;

        .header-invoice-table-date {
          text-align: end;
        }
      }
    }

  }

  .invoice-text-title {
    //background: #1e90ff;
    padding: 8px 10px;
    //color: white;
    font-size: 26px !important;
  }


  .only-table-td {
    color: white;
    background: #0f163a;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .custom-table-data {
    width: 100%;
    margin-top: 12px;

    th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }

    tr {
      th {
        text-align: center;
        padding: 0px 6px;
      }

      td {
        padding: 0px 4px;
      }
    }


    .table-header {
      color: white !important;
      background: #4d4d4d;

      th {
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }

    .table-bg-color {
      background: #f2f2f2;
    }

    .table-bg-color:nth-child(even) {
      background: #FFFFFF !important;
    }

    .table-data {
      td {
        padding-top: 4px;
        padding-bottom: 4px;
      }


      th {
        padding-top: 4px;
        padding-bottom: 4px;
      }
    }

    .table-data-w-10 {
      width: 10px;
      height: 6px;
      border: none !important;
      background: #FFFFFF !important;
    }

  }

  td {
    word-break: break-word;
  }

  .top-side-bar {
    font-size: 16px !important;
  }

  @page {
    size: A4;
    margin: 10mm 0;
  }
  @media print {
    background-color: #fff !important;
    .pagebreak {
      page-break-after: always;
      break-after: page;
    }

    //font-size: 10px !important;

    thead {
      display: table-header-group;
    }
    th, td {
      //font-size: 10px !important;
      padding: 0 1px !important;
    }
    tfoot {
      display: table-footer-group;
    }
    .width-400 {
      width: 180px;
      min-width: 180px;
      max-width: 180px;
    }


    button {
      display: none;
    }
    body {
      margin: 10mm 0;
      background: white;
    }
    #page-footer {
      position: fixed;
      bottom: 0;
    }
    #page-header {
      position: fixed;
      top: 0;
      padding-right: 32px;
    }

    .page-header-space {
      height: 16px;
      background-color: white;
    }
    .page-footer-space {
      height: 98px;
      background-color: white;
    }

    .page-footer {
      width: 100%;
      border-top: 1px dotted #0000003D;
      border-bottom: 1px dotted #0000003D;
      color: black;
      background-color: white;
      font-size: 10px !important;
      line-height: 1rem;
    }

    .header-invoice-tittle {
      font-size: 30px !important;
    }

    .header-title-text {
      font-size: 28px !important;
    }

    .invoice-text-title {
      font-size: 24px !important;
    }

    .custom-customer-table {
      tr {
        td {
          padding-right: 0;
        }
      }
    }

    .header-title-text, .header-invoice, .header-invoice-details, .header-title-bg, .header-title-bg-1, .header-title-bg-2, .header-title-bg-3 {
      height: 140px !important;
    }
    .header-invoice-details {
      display: flex;
      justify-content: flex-end;

      img {
        object-fit: contain;
      }

      .header-invoice-tittle {
        height: 140px !important;
      }
    }


    .print-invoice {
      .header-invoice {
        background-color: white;
      }
    }

    .top-side-bar {
      th, td {
        font-size: 14px !important;
      }

      p {
        font-size: 14px !important;
      }
    }
    .width-80 {
      max-width: 80px !important;
      min-width: 20px !important;
    }
    .width-40 {
      max-width: 40px !important;
      min-width: 20px !important;
    }
    .no-word-break {
      word-break: keep-all;
    }
  }

  .invoice-static-content {
    text-align: center;
    padding-top: 34px;
    color: #626262 !important;
  }

  footer {
    display: none !important;
  }

  #page-footer {

    text-align: center;
  }

  #page-header {
    text-align: center;
  }

}
</style>

